export default {
	data() {
		return {
			filterSaler: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterSaler._id": {
			handler(val) {
				let fieldName = "saler";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	}
};
